import { useEffect } from "react";
import { IHook } from "./homeNewsletter.types";

export const useHomeNewsletter: IHook = ({ showModal }) => {
  useEffect(() => {
    if (!showModal) {
      return;
    }

    showModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
